import { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";

function DropdownAction({ dropdownItems, isVerticalIcon }) {
    const uid = "react-aria" + Date.now();

    return (
        <Fragment>
            <button
                type="button"
                id={uid}
                aria-expanded="false"
                data-bs-toggle="dropdown"
                className={`cursor-pointer z-1 fs-10 btn-square-sm dropdown-caret-none dropdown-toggle position-relative btn ${!isVerticalIcon && "btn-bt-secondary" }` }
            >
                <FontAwesomeIcon icon={ isVerticalIcon ? faEllipsisVertical : faEllipsis} />
            </button>

            <div
                aria-labelledby={uid}
                className="dropdown-menu dropdown-menu-end"
                data-popper-placement="bottom-end"
                style={{
                    zIndex: 6,
                    position: "absolute",
                    inset: "0px 0px auto auto",
                    transform: "translate(0px, 32px)",
                }}
            >
                {dropdownItems &&
                    dropdownItems.map((item, index) => (
                        <a
                            key={index}
                            href="#"
                            className={`text-decoration-none dropdown-item ${item.className || ""}`}
                            role="button"
                            tabIndex="0"
                            onClick={(e) => {
                                e.preventDefault();
                                item.onClick && item.onClick();
                            }}
                        >
                            {
                                item.icon && <FontAwesomeIcon className="me-3 text-primary" icon={ item.icon } />
                            }
                            {item.text}
                        </a>
                    ))}
            </div>
        </Fragment>
    );
}

export default DropdownAction;
